/* This example requires Tailwind CSS v2.0+ */
import {} from 'react-icons/fa';

 const Card = ({ icony, name, description }) => (
   <>
     <div className='mb-4 md:mb-0 md:absolute flex items-center justify-center rounded-full shadow md:shadow-none mx-auto bg-gray-200 md:bg-white w-20 h-20 md:h-12 md:w-12'>
       {icony}
     </div>
     <p className='md:mr-16 text-lg leading-6 font-medium text-gray-900'>{name}</p>
     <p className='px-20 md:px-0 mt-2 md:mr-16 text-base text-gray-700'>{description}</p>
   </>
 )


export default Card

